import { initLeadSource } from "./leadSource";

const API = process.env.REACT_APP_BACKEND_URL;
const SID_KEY = "gd_sid";

export function getSessionId() {
  try {
    let sid = localStorage.getItem(SID_KEY);
    if (!sid) {
      sid = typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `s-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      localStorage.setItem(SID_KEY, sid);
    }
    return sid;
  } catch {
    return "anonymous";
  }
}

let firstTrack = true;

// Pages where lingering signals buying intent — services, locations, quote, contact
const HIGH_INTENT_RE = /^\/(request-a-quote|contact|services|land-survey|topographic|boundary|alta|as-built|gis-|mortgage|subdivision|easement|construction|utility|route-|drone-|fema-|cadastral|plot-plan|grading-|road-highway|pdf-to-cad|point-cloud|survey-data)/;

function dwellBeacon(path) {
  setTimeout(() => {
    try {
      if (document.visibilityState === "hidden") return;
      fetch(`${API}/api/track`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: getSessionId(), path, dwell: 45 }),
        keepalive: true,
      }).catch(() => {});
    } catch {
      /* analytics must never break the page */
    }
  }, 45000);
}

export function track(path) {
  try {
    const payload = { session_id: getSessionId(), path };
    if (firstTrack) {
      payload.referrer = document.referrer || null;
      initLeadSource();
      firstTrack = false;
    }
    fetch(`${API}/api/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
    if (HIGH_INTENT_RE.test(path)) dwellBeacon(path);
  } catch {
    /* analytics must never break the page */
  }
}
